import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MessageCircle, Phone } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#030303] border-t border-white/10 pt-14 pb-7" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img src="/Logo-removebg-preview.png" alt="RRIDE MOTO STUDIO" className="w-28 h-28 object-contain" />
            </div>
            <div className="text-2xl font-bold mb-4" style={{ fontFamily: 'Cinzel, serif', letterSpacing: "0.1em" }}>
              <span className="text-white">RRIDE</span>
              <span className="text-primary ml-1">MOTO</span>
              <span className="text-white ml-1">STUDIO</span>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Premium motorcycle accessories, Outrans Originals, riding gear, and trusted upgrades built for everyday riders.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider" style={{ fontFamily: 'Cinzel, serif', letterSpacing: "0.1em" }}>
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-zinc-400 hover:text-primary transition-colors text-sm">
                  Shop Products
                </Link>
              </li>
              <li>
                <Link to="/orders" className="text-zinc-400 hover:text-primary transition-colors text-sm">
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/wishlist" className="text-zinc-400 hover:text-primary transition-colors text-sm">
                  Wishlist
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-zinc-400 hover:text-primary transition-colors text-sm">
                  About RRide
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-primary transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider" style={{ fontFamily: 'Cinzel, serif', letterSpacing: "0.1em" }}>
              Policies
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-zinc-400 hover:text-primary transition-colors text-sm">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-zinc-400 hover:text-primary transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-zinc-400 hover:text-primary transition-colors text-sm">
                  Returns
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-zinc-400 hover:text-primary transition-colors text-sm">
                  Shipping & Delivery
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider" style={{ fontFamily: 'Cinzel, serif', letterSpacing: "0.1em" }}>
              Support
            </h3>
            <div className="space-y-3">
              <a
                href="tel:+918793678780"
                className="flex items-center space-x-2 text-zinc-400 hover:text-primary transition-colors text-sm"
              >
                <Phone size={16} />
                <span>+91 8793678780</span>
              </a>
              <a
                href="https://wa.me/918793678780"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-sm hover:bg-green-500 transition-colors"
                data-testid="whatsapp-btn"
              >
                <MessageCircle size={18} />
                <span className="text-sm font-semibold">WhatsApp Expert</span>
              </a>
              <a
                href="mailto:rridemods@gmail.com"
                className="flex items-center space-x-2 text-zinc-400 hover:text-primary transition-colors text-sm"
              >
                <span>rridemods@gmail.com</span>
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-zinc-400 hover:text-primary transition-colors text-sm"
              >
                <Instagram size={16} />
                <span>Instagram</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 text-center">
          <p className="text-zinc-500 text-sm">
            © 2024 RRIDE MOTO STUDIO. All rights reserved. | Built for Riders, By Riders.
          </p>
        </div>
      </div>
    </footer>
  );
};
